export default __webpack_public_path__ + "static/hero-image-4-198c1fe1f113628686161f975ac1c8fa.jpg";